import React, { Component } from "react";
import UniversalCookie from 'universal-cookie'
import { Router, Route, Switch } from "react-router-dom";
import {Provider} from 'react-redux';
import Loadable from 'react-loadable';


// import Home from './containers/home/index'
// import HomeBak from './containers/home/index.bak'
// import Campaigns from './containers/campaigns'
// import CampaignsDetail from './containers/campaigns/detail'
// import CampaignsJoin from './containers/campaigns/join'
// import Orders from './containers/orders'
// import OrdersDetail from './containers/orders/detail'
// import OrdersChat from './containers/orders/chat'
// import Ordershistory from './containers/orders/history'
// import SendLink from './containers/orders/sendLink'
// import Pesan from './containers/pesan'
// import PesanDetail from './containers/pesan/detail';
// import Billing from './containers/billing'
// import BillingType from './containers/billing/type'
// import BillingBankEdit from './containers/billing/editBank'
// import Akun from './containers/akun'
// import AkunDetail from './containers/akun/detail'
// import AkunReviews from './containers/akun/reviewsDetail'
// import AssetEdit from './containers/akun/assetEdit'
// import AssetVerify from './containers/akun/assetVerify'
// import AssetEditRequest from './containers/akun/assetRequest'
// import AkunSettings from './containers/akun/settings'
// import AkunSettingsDetail from './containers/akun/settingsDetail'
// import AkunCreate from './containers/akun/create'
// import AssetDelete from './containers/akun/assetDelete'

import loader from './assets/images/loader.svg'

import configureStore from './store'
import history from './helper/history';

import {login, parseStorage} from './action'
const isDevelopment = process.env.NODE_ENV === 'development';

const store = configureStore();
const Loading = () => 
<div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh'}}>
  <img src={loader} />
</div>

const Home = Loadable({
  loader: () => import('./containers/home/index'),
  loading: Loading
})

const Campaigns = Loadable({
  loader: () => import('./containers/campaigns'),
  loading: Loading
})

const CampaignsDetail = Loadable({
  loader: () => import('./containers/campaigns/detail'),
  loading: Loading
})

const Orders = Loadable({
  loader: () => import('./containers/orders'),
  loading: Loading
})


const OrdersDetail = Loadable({
  loader: () => import('./containers/orders/detail'),
  loading: Loading
})

const OrdersChat = Loadable({
  loader: () => import('./containers/orders/chat'),
  loading: Loading
})

const Ordershistory = Loadable({
  loader: () => import('./containers/orders/history'),
  loading: Loading
})

const Pesan = Loadable({
  loader: () => import('./containers/pesan'),
  loading: Loading
})

const PesanDetail = Loadable({
  loader: () => import('./containers/pesan/detail'),
  loading: Loading
})

const Billing = Loadable({
  loader: () => import('./containers/billing'),
  loading: Loading
})

const BillingType = Loadable({
  loader: () => import('./containers/billing/type'),
  loading: Loading
})

const Akun = Loadable({
  loader: () => import('./containers/akun'),
  loading: Loading
})


const AkunDetail = Loadable({
  loader: () => import('./containers/akun/detail'),
  loading: Loading
})

const AkunReviews = Loadable({
  loader: () => import('./containers/akun/reviewsDetail'),
  loading: Loading
})

const AssetEdit = Loadable({
  loader: () => import('./containers/akun/assetEdit'),
  loading: Loading
})

const AssetVerify = Loadable({
  loader: () => import('./containers/akun/assetVerify'),
  loading: Loading
})

const AssetEditRequest = Loadable({
  loader: () => import('./containers/akun/assetRequest'),
  loading: Loading
})

const AkunSettings = Loadable({
  loader: () => import('./containers/akun/settings'),
  loading: Loading
})

const AkunSettingsDetail = Loadable({
  loader: () => import('./containers/akun/settingsDetail'),
  loading: Loading
})

const AkunCreate = Loadable({
  loader: () => import('./containers/akun/create'),
  loading: Loading
})


const AkunCreateStep2 = Loadable({
  loader: () => import('./containers/akun/create/step2'),
  loading: Loading
})


const AkunCreateSuccess = Loadable({
  loader: () => import('./containers/akun/create/success'),
  loading: Loading
})

const ChannelCreate = Loadable({
  loader: () => import('./containers/akun/create/portfolio'),
  loading: Loading
})


const ChannelStep2 = Loadable({
  loader: () => import('./containers/akun/create/portfolioStep2'),
  loading: Loading
})


const ChannelSuccess = Loadable({
  loader: () => import('./containers/akun/create/success'),
  loading: Loading
})

const AssetDelete = Loadable({
  loader: () => import('./containers/akun/assetDelete'),
  loading: Loading
})


const Contest = Loadable({
  loader: () => import('./containers/contest'),
  loading: Loading
})

const ContestDetail = Loadable({
  loader: () => import('./containers/contest/detail'),
  loading: Loading
})


const ContestDetailType = Loadable({
  loader: () => import('./containers/contest/detail/index'),
  loading: Loading
})

const ContestEntriesType = Loadable({
  loader: () => import('./containers/contest/detail/_entries'),
  loading: Loading
})


const ContestJoin = Loadable({
  loader: () => import('./containers/contest/join'),
  loading: Loading
})

const ContestComment = Loadable({
  loader: () => import('./containers/contest/detail/comment'),
  loading: Loading
})

const Articles =  Loadable({
  loader: () => import('./containers/articles'),
  loading: Loading
})

const ArticlesDetail =  Loadable({
  loader: () => import('./containers/articles/detail'),
  loading: Loading
})

const ArticlesOrders = Loadable({
  loader: () => import('./containers/articles/orders'),
  loading: Loading
})
 

const ArticlesHistory = Loadable({
  loader: () => import('./containers/articles/history'),
  loading: Loading
})

const ArticlesHistoryDetail = Loadable({
  loader: () => import('./containers/articles/historyDetail'),
  loading: Loading
})

const Awards = Loadable({
  loader: () => import('./containers/awards'),
  loading: Loading
})

const AwardsGame = Loadable({
  loader: () => import('./containers/awards/game'),
  loading: Loading
})

const AwardsHistoryDetail = Loadable({
  loader: () => import('./containers/awards/historyDetail'),
  loading: Loading
})


const AwardsHistory = Loadable({
  loader: () => import('./containers/awards/history'),
  loading: Loading
})


class NotFound extends Component{
  render(){
    return(
      <div>Page Not Found</div>
    )
  }
}

class AppRouter extends Component{
  state = {
    auth: null
  }

  componentWillMount = () => {
    // isDevelopment && login()
    const cookie = new UniversalCookie()
    const auth = cookie.get('auth');
    
    if(!auth){
      window.location.href = "/login"
    }


    this.setState({
      auth
    })
  }

  render(){  
    const {auth} = this.state
    return (
      <Provider store={store}>
        <Router history={history}>
            {
              auth ?
              <div>
                <Switch >

                  <Route path="/influencer/overview" exact component={Home} />

                  <Route path="/influencer/campaign" exact component={Campaigns} />
                  <Route path="/influencer/campaign/:id" component={CampaignsDetail} />
                  
                  <Route path="/influencer/task" exact component={Orders} />
                  <Route path="/influencer/task/history" component={Ordershistory} />
                  <Route path="/influencer/task/:id/chat" exact component={OrdersChat} />
                  <Route path="/influencer/task/:id" component={OrdersDetail} />
                
                  
                  <Route path="/influencer/pesan/:id/show" exact component={PesanDetail} />
                  <Route path="/influencer/pesan" component={Pesan} />


                  <Route path="/influencer/billing/:type" component={BillingType} />
                  <Route path="/influencer/billing" component={Billing} />
                  <Route path="/influencer/bank/:type" exact component={Billing} />
                  
                  <Route path="/influencer/akun/channel/create" exact component={AkunCreate} />
                  <Route path="/influencer/akun/channel/create/:channel" exact component={AkunCreateStep2} />
                  <Route path="/influencer/akun/channel/create/:channel/success" exact component={AkunCreateSuccess} />

                  <Route path="/influencer/akun/portfolio/create" exact component={ChannelCreate} />
                  <Route path="/influencer/akun/portfolio/create/:channel" exact component={ChannelStep2} />
                  <Route path="/influencer/akun/portfolio/create/:channel/success" exact component={ChannelSuccess} />

                  <Route path="/influencer/akun/settings/:type" exact component={AkunSettingsDetail} />
                  <Route path="/influencer/akun/settings" exact component={AkunSettings} />
                  <Route path="/influencer/akun/channel/edit/:id" exact component={AssetEdit} />
                  <Route path="/influencer/akun/channel/verify" exact component={AssetVerify} />
                  <Route path="/influencer/akun/channel/edit/:id/request" exact component={AssetEditRequest} />
                  <Route path="/influencer/akun/channel/edit/:id/delete" exact component={AssetDelete} />
                  <Route path="/influencer/akun/channel/:channel" exact component={AkunDetail} />
                  <Route path="/influencer/akun/reviews/all" exact component={AkunReviews} />

                  <Route path="/influencer/akun/:type" exact component={Akun} />

                  <Route path="/influencer/contest" exact component={Contest} />
                  <Route path="/influencer/contest/:id/join" exact component={ContestJoin} />
                  <Route path="/influencer/contest/:id/discuss/comment" exact component={ContestComment} />
                  <Route path="/influencer/contest/:id/entries" exact component={ContestEntriesType} />
                  <Route path="/influencer/contest/:id/:type" exact component={ContestDetailType} />
                  <Route path="/influencer/contest/:id" component={ContestDetail} />

                  <Route path="/influencer/articles" exact component={Articles} />
                  <Route path="/influencer/articles/orders" exact component={ArticlesHistory} />
                  <Route path="/influencer/articles/orders/:id" exact component={ArticlesHistoryDetail} />
                  <Route path="/influencer/articles/:type" exact component={ArticlesDetail} />
                  <Route path="/influencer/articles/:type/:package" exact component={ArticlesOrders} />

                  <Route path="/influencer/awards" exact component={Awards} />
                  <Route path="/influencer/awards/game" exact component={AwardsGame} />
                  <Route path="/influencer/awards/history" exact component={AwardsHistory} />
                  <Route path="/influencer/awards/history/:id" exact component={AwardsHistoryDetail} />

                  
                  
                  


                  <Route component={NotFound} />
                </Switch>
              </div>:
              <div>Not Found</div>
            }
        </Router>
      </Provider>
    );
  }
}

  
export default AppRouter;